import {blogActionTypes} from "../_constants";

export function blog(state = {posts: {}}, action) {
  
  switch (action.type) {

    // get blog posts request
    case blogActionTypes.GET_BLOG_ARTICLES_REQUEST:
      return {
        ...state,
        posts: {
          [action.tagId]: {
            isLoading: true,
            isLoaded: false,
            isFailed: false,
          }
        }
      }

    // get blog posts success
    case blogActionTypes.GET_BLOG_ARTICLES_SUCCESS:
      return {
        ...state,
        posts: {
          [action.tagId]: {
            isLoading: false,
            isLoaded: true,
            isFailed: false,
            list: action.graphTags
          }
        }
      }

    // get blog posts failure
    case blogActionTypes.GET_BLOG_ARTICLES_FAILURE:
      return {
        ...state,
        posts: {
          [action.tagId]: {
            isLoading: false,
            isLoaded: false,
            isFailed: true,
          }
        }
      }

    default:
      return state
  }
}